import {useCombobox, UseComboboxState, UseComboboxStateChangeOptions} from "downshift";
import {RefObject} from "react";
import {BasicItem} from "./types";

export const SINGLE_SELECT = "singleSelect";
export const MULTI_SELECT = "multiSelect";

// function to control on more depth level
export const singleSelectStateReducerCallback = <T extends HTMLElement, U extends BasicItem>(
    selectId: RefObject<T> | null,
) => (
    state: UseComboboxState<U>,
    actionAndChanges: UseComboboxStateChangeOptions<U>,
): UseComboboxState<U> => {
    const {changes, type} = actionAndChanges;
    switch (type) {
        case useCombobox.stateChangeTypes.InputKeyDownEscape:
            setTimeout(() => {
                selectId?.current?.focus();
            }, 0);

            return {
                ...changes,
                inputValue: "", // don't add the item string as input value at selection.
                selectedItem: state.selectedItem,
            };
        case useCombobox.stateChangeTypes.InputBlur:
        case useCombobox.stateChangeTypes.ItemClick:
        case useCombobox.stateChangeTypes.ToggleButtonClick: {
            setTimeout(() => {
                selectId?.current?.focus();
            }, 0);
            return {
                ...changes,
                inputValue: "", // don't add the item string as input value at selection.
            };
        }

        default:
            return changes;
    }
};

export const defaultItemToString = <T extends BasicItem>(item: T): string => {
    if (Array.isArray(item)) {
        return `${item.length} elements selected`;
    } else {
        return item ? item.label : "";
    }
};
export const defaultItemToStringForMultiSelect = <T extends BasicItem>(item: T): string =>
    item ? item.label : "";

export const multiSelectStateReducerCallback = <T extends HTMLElement, U extends BasicItem>(
    selectId: RefObject<T>,
) => (
    state: UseComboboxState<U>,
    actionAndChanges: UseComboboxStateChangeOptions<U>,
): UseComboboxState<U> => {
    const {changes, type} = actionAndChanges;

    switch (type) {
        case useCombobox.stateChangeTypes.InputKeyDownEnter:
        case useCombobox.stateChangeTypes.ItemClick:
            return {
                ...changes,
                isOpen: true, // keep menu open after selection.
                highlightedIndex: state.highlightedIndex,
                inputValue: "", // don't add the item string as input value at selection.
            };
        case useCombobox.stateChangeTypes.InputBlur:
        case useCombobox.stateChangeTypes.InputKeyDownEscape:
        case useCombobox.stateChangeTypes.ToggleButtonClick: {
            setTimeout(() => {
                selectId?.current?.focus();
            }, 0);
            return {
                ...changes,
                inputValue: "", // don't add the item string as input value at selection.
            };
        }

        default:
            return changes;
    }
};

// export const itemToStringBasic = <T extends Item>(item: T): string => {
//     return item ? item.value : "";
// };

export const onSelectedItemCallback = <T extends BasicItem>(
    //selectedItems,
    //setSelectedItems,
    multiSelectedItems: T[],
    setMultiSelectedItems: React.Dispatch<React.SetStateAction<T[]>>,
    inputRFF:
        | {
              onChange: <T>(abc: T) => void;
              name: string;
          }
        | undefined,
) => ({selectedItem}: {selectedItem: T | undefined}): void => {
    if (!selectedItem) {
        return;
    }
    const bucketIndex = multiSelectedItems.map((e) => e.id).indexOf(selectedItem.id);
    let finalMultiSelectItem;
    if (bucketIndex >= 0) {
        finalMultiSelectItem = [
            ...multiSelectedItems.slice(0, bucketIndex),
            ...multiSelectedItems.slice(bucketIndex + 1),
        ];
    } else {
        if (multiSelectedItems.length > 0) {
            finalMultiSelectItem = [...multiSelectedItems, selectedItem];
        } else {
            finalMultiSelectItem = [selectedItem];
        }
    }
    if (finalMultiSelectItem.length > 0) {
        setMultiSelectedItems(finalMultiSelectItem);
        inputRFF?.onChange(finalMultiSelectItem);
    } else {
        setMultiSelectedItems([]);
        inputRFF?.onChange(undefined);
    }

    // selectedItem = selectedItem.id;
    // if (!selectedItem) {
    //     return;
    // }
    // const index = selectedItems.indexOf(selectedItem);
    // if (index > 0) {
    //     setSelectedItems([
    //         ...selectedItems.slice(0, index),
    //         ...selectedItems.slice(index + 1),
    //     ]);
    // } else if (index === 0) {
    //     setSelectedItems([...selectedItems.slice(1)]);
    // } else {
    //     setSelectedItems([...selectedItems, selectedItem]);
    // }
};
